import { getButtonOptionByFlags } from "./lib/getButtonOptionByFlags.js";
import React from "react";
import { cn } from "@synthesis/shared-utils";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/Button/index.tsx
const buttonSizeMap = {
	HasLeftIcon: {
		lg: "h-12 gap-2 rounded-[0.875rem] py-3 pl-5 pr-6",
		md: "h-10 gap-2 rounded-xl py-2 pl-4 pr-5",
		sm: "h-8 gap-1 rounded-[0.625rem] py-1.5 pl-2 pr-3",
		xs: "h-6 gap-1 rounded-lg"
	},
	HasRightIcon: {
		lg: "h-12 gap-2 rounded-[0.875rem] py-3 pl-6 pr-5",
		md: "h-10 gap-2 rounded-xl py-2 pl-5 pr-4",
		sm: "h-8 gap-1 rounded-[0.625rem] py-1.5 pl-3 pr-2",
		xs: "h-6 rounded-lg"
	},
	HasNoLabel: {
		lg: "size-12 rounded-[0.875rem] px-3 py-3",
		md: "size-10 rounded-xl px-2 py-2",
		sm: "size-8 rounded-[0.625rem] px-1.5 py-1.5",
		xs: "size-6 rounded-lg px-0 py-0"
	},
	HasNoIcon: {
		lg: "h-12 rounded-[0.875rem] px-[22px] py-3",
		md: "h-10 rounded-xl px-4 py-2",
		sm: "h-8 rounded-[0.625rem] px-3 py-1.5",
		xs: "h-6 rounded-lg"
	}
};
const buttonSizeLabelMap = {
	lg: "text-base",
	md: "text-base",
	sm: "text-sm",
	xs: "text-sm"
};
const buttonShapePagination = { square: {
	lg: "size-12 p-0",
	md: "size-10 p-0",
	sm: "size-8 p-0",
	xs: "size-6 p-0"
} };
const buttonThemeMap = {
	wrapper: {
		primary: "bg-brand-40 hover:bg-brand-30 disabled:bg-neutrals-80 border-transparent",
		secondary: "bg-neutrals-white border-neutrals-90 hover:bg-neutrals-99 hover:border-neutrals-80 disabled:bg-neutrals-95 disabled:border-neutrals-90",
		elevated: "bg-neutrals-white shadow-lg hover:bg-neutrals-95 disabled:bg-neutrals-95 disabled:shadow-none",
		text: "bg-transparent hover:bg-neutrals-95"
	},
	label: {
		primary: "text-neutrals-white group-disabled:text-type-white",
		secondary: "text-labels-secondary group-disabled:text-neutrals-70",
		elevated: "text-labels-secondary group-disabled:text-neutrals-70",
		text: "text-labels-secondary group-disabled:text-neutrals-70"
	},
	icon: {
		primary: "text-neutrals-white group-disabled:text-neutrals-70",
		secondary: "text-neutrals-60 group-disabled:text-neutrals-70",
		elevated: "text-neutrals-60 group-disabled:text-neutrals-70",
		text: "text-neutrals-60 group-disabled:text-neutrals-70"
	}
};
const Button = React.forwardRef(({ children, onClick: handleClick, isFullWidth, size = "md", theme = "secondary", customClassNames = [], type = "button", shape = "base", disabled = false, icon, leftIcon, rightIcon, withoutOutlineOnFocus = false, className, action: _action, ...rest }, ref) => {
	const buttonMarginsVariant = getButtonOptionByFlags(Boolean(leftIcon), Boolean(rightIcon), Boolean(icon), Boolean(children));
	return /* @__PURE__ */ jsx("button", {
		"data-cy": "buttonComponent-buttonWrapper",
		disabled,
		type,
		onClick: handleClick,
		ref,
		className: cn("group flex shrink-0 cursor-pointer items-center justify-center border-2 border-solid border-transparent p-0 transition-colors", buttonSizeMap[buttonMarginsVariant][size], buttonThemeMap.wrapper[theme], isFullWidth && "w-full", !withoutOutlineOnFocus && "outline-system-info-70 focus:outline focus:outline-2 focus:outline-offset-1", shape === "square" && buttonShapePagination.square[size], buttonSizeLabelMap[size], leftIcon && rightIcon && "w-auto", ...customClassNames, className),
		...rest,
		children: icon ? /* @__PURE__ */ jsx("span", {
			className: buttonThemeMap.icon[theme],
			children: icon
		}) : /* @__PURE__ */ jsxs(Fragment, { children: [
			leftIcon && /* @__PURE__ */ jsx("span", {
				className: buttonThemeMap.icon[theme],
				children: leftIcon
			}),
			children && /* @__PURE__ */ jsx("span", {
				className: cn("truncate font-medium", buttonThemeMap.label[theme]),
				children
			}),
			rightIcon && /* @__PURE__ */ jsx("span", {
				className: buttonThemeMap.icon[theme],
				children: rightIcon
			})
		] })
	});
});
Button.displayName = "Button";
//#endregion
export { Button };

//# sourceMappingURL=index.js.map